"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const TriggerNode_1 = require("./TriggerNode");
const ResourceNode_1 = require("./ResourceNode");
const ActionNode_1 = require("./ActionNode");
const FilterNode_1 = require("./FilterNode");
const MonitoringNode_1 = require("./MonitoringNode");
const NotificationNode_1 = require("./NotificationNode");
const ReportNode_1 = require("./ReportNode");
const AzureResourceNode_1 = require("./AzureResourceNode");
const AzureActionNode_1 = require("./AzureActionNode");
const AzureMonitoringNode_1 = require("./AzureMonitoringNode");
const VmwareNode_1 = require("./VmwareNode");
const VmwareActionNode_1 = require("./VmwareActionNode");
const UserApprovalNode_1 = require("./UserApprovalNode");
const DelayNode_1 = require("./DelayNode");
const HttpNode_1 = require("./HttpNode");
const CustomNode_1 = require("./CustomNode");
const JenkinsNode_1 = require("./JenkinsNode");
const WorkflowNode_1 = require("./WorkflowNode");
const WolkenNode_1 = require("./WolkenNode");
const WorkflowReportNode_1 = require("./WorkflowReportNode");
const SSHNode_1 = require("./SSHNode");
const ThrottlingNode_1 = require("./ThrottlingNode");
const AdoptionNode_1 = require("./AdoptionNode");
const NetworkNode_1 = require("./NetworkNode");
const K8ResourceNode_1 = require("./K8ResourceNode");
const K8ActionNode_1 = require("./K8ActionNode");
const DecisionNode_1 = require("./DecisionNode");
const ParallelNode_1 = require("./ParallelNode");
const TerraformActionNode_1 = require("./TerraformActionNode");
const TerraformResourceNode_1 = require("./TerraformResourceNode");
const UserDefinedNode_1 = require("./UserDefinedNode");
const extendedTypes_1 = require("../types/extendedTypes");
const DataFormatterNode_1 = require("./DataFormatterNode");
const DataJoinerNode_1 = require("./DataJoinerNode");
const GCPResourceNode_1 = require("./GCPResourceNode");
const GCPActionNode_1 = require("./GCPActionNode");
exports.nodeTypeMapper = {
  [types_1.NODE_TYPES.TRIGGER]: TriggerNode_1.TriggerNode,
  [types_1.NODE_TYPES.RESOURCE]: ResourceNode_1.ResourceNode,
  [types_1.NODE_TYPES.ACTION]: ActionNode_1.ActionNode,
  [types_1.NODE_TYPES.FILTER]: FilterNode_1.FilterNode,
  [types_1.NODE_TYPES.MONITORING]: MonitoringNode_1.MonitoringNode,
  [types_1.NODE_TYPES.NOTIFICATION]: NotificationNode_1.NotificationNode,
  [types_1.NODE_TYPES.REPORT]: ReportNode_1.ReportNode,
  [types_1.NODE_TYPES.USER_APPROVAL]: UserApprovalNode_1.UserApprovalNode,
  [types_1.NODE_TYPES.DELAY]: DelayNode_1.DelayNode,
  [types_1.NODE_TYPES.HTTP]: HttpNode_1.HttpNode,
  [types_1.NODE_TYPES.CUSTOM]: CustomNode_1.CustomNode,
  [types_1.NODE_TYPES.JENKINS]: JenkinsNode_1.JenkinsNode,
  [types_1.NODE_TYPES.WORKFLOW]: WorkflowNode_1.WorkflowNode,
  [types_1.NODE_TYPES.Azure_Resource]: AzureResourceNode_1.AzureResourceNode,
  [types_1.NODE_TYPES.Azure_Action]: AzureActionNode_1.AzureActionNode,
  [types_1.NODE_TYPES.Azure_Monitoring]:
    AzureMonitoringNode_1.AzureMonitoringNode,
  [types_1.NODE_TYPES.VMWARE]: VmwareNode_1.VmwareNode,
  [types_1.NODE_TYPES.VMWARE_ACTION]: VmwareActionNode_1.VmwareActionNode,
  [types_1.NODE_TYPES.WOLKEN]: WolkenNode_1.WolkenNode,
  [types_1.NODE_TYPES.SSH]: SSHNode_1.SSHNode,
  [types_1.NODE_TYPES.NETWORK]: NetworkNode_1.NetworkScanNode,
  [types_1.NODE_TYPES.K8_Resource]: K8ResourceNode_1.K8ResourceNode,
  [types_1.NODE_TYPES.K8_Action]: K8ActionNode_1.K8ActionNode,
  [types_1.NODE_TYPES.WORKFLOW_REPORT]: WorkflowReportNode_1.WorkflowReportNode,
  [types_1.NODE_TYPES.THROTTLING]: ThrottlingNode_1.ThrottlingNode,
  [types_1.NODE_TYPES.ADOPTION]: AdoptionNode_1.AdoptionNode,
  [types_1.NODE_TYPES.Decision]: DecisionNode_1.DecisionNode,
  [types_1.NODE_TYPES.Parallel]: ParallelNode_1.ParallelNode,
  [types_1.NODE_TYPES.TerraformCloudAction]:
    TerraformActionNode_1.TerraformActionNode,
  [types_1.NODE_TYPES.TerraformCloudResource]:
    TerraformResourceNode_1.TerraformResourceNode,
  [types_1.NODE_TYPES.UserDefinedNode]: UserDefinedNode_1.UserDefinedNode,
  [types_1.NODE_TYPES.DataFormatter]: DataFormatterNode_1.DataFormatterNode,
  [types_1.NODE_TYPES.DataJoiner]: DataJoinerNode_1.DataJoinerNode,
  [types_1.NODE_TYPES.GCP_Resource]: GCPResourceNode_1.GCPResourceNode,
  [types_1.NODE_TYPES.GCP_Action]: GCPActionNode_1.GCPActionNode
};
exports.extendNodeTypeMapper = function(nodeDefinition) {
  const nodeType = extendedTypes_1.getUserDefinedNodeType(
    types_1.NODE_TYPES.UserDefinedNode,
    nodeDefinition.id
  );
  exports.nodeTypeMapper[
    nodeType
  ] = class extends UserDefinedNode_1.UserDefinedNode {
    constructor(props) {
      super(props);
      this.setNodeDefinition(nodeDefinition);
    }
  };
};
//# sourceMappingURL=NodeTypeMapper.js.map
